import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#211F29",
      d: "M9.005 1.36c2.2-1.046 3.307-1.567 4.2-.907s.693 1.854.293 4.227l-.64 3.8c-.266 1.546-.407 2.38-1.14 2.806a1.53 1.53 0 0 1-.8.214l-.006-.007c-.557 0-1.228-.231-2.172-.555l-.008.015-.56.8c-1.013 1.34-1.567 2.087-2.247 2.087l.007-.007q-.13-.001-.26-.033c-.846-.227-.846-1.147-.846-2.98V9.586l-.387-.133C1.632 8.48.239 7.993.165 6.786c-.066-1.22 1.28-1.852 3.96-3.119zm-3.18 9.46c0 .92 0 1.867.14 2.04.174-.066.8-.893 1.4-1.693l.397-.566-1.936-.67zm6.773-9.573c-.407-.3-1.446.193-3.173 1.006L4.545 4.56v.006c-2.06.974-3.413 1.614-3.386 2.16.033.54 1.446 1.034 3.586 1.774l.272.094L9.972 3.64a.503.503 0 0 1 .706 0 .504.504 0 0 1 0 .707l-4.61 4.609 2.944 1.018c1.293.446 1.874.633 2.193.446.313-.187.427-.774.654-2.087l.64-3.807c.3-1.806.499-2.986.099-3.279"
    }, null, -1)
  ]))]))
}
export default { render: render }